export default "/images/vendor/flag-icon-css/flags/1x1/lu.svg?b843e6436ac12254b9d23ba3fc407e37";